import { hasLeadingOrTrailingSpace } from "../../../../logic/RegexValidation";
import { getStringErrors, getValidationErrorDictionary, getValidationErrors, isValidEmail } from "../../../../logic/ValidationChecks/Validation";
import { ValidationCheck } from "../../../../stores/models/ValidationCheck";
import { ValidationError } from "../../../../stores/models/ValidationError";
import { AccountDetailsStepValues } from "../_interfaces/IOrganizationSignUpStepTypeValues";

export const MIN_PASSWORD_LENGTH = 6;

const validationChecks: (stepValues: AccountDetailsStepValues) => ValidationCheck<AccountDetailsStepValues>[] =
    (stepValues) => [{
        name: 'valid email',
        condition: (stepValues: AccountDetailsStepValues) => {
            return isValidEmail(stepValues.username);
        },
        error: new ValidationError('You must enter a valid email.', ['username'])
    }, {
        name: 'password no leading or trailing spaces',
        condition: (stepValues: AccountDetailsStepValues) => {
            return !hasLeadingOrTrailingSpace(stepValues.password);
        },
        error: new ValidationError('Your password should not have any leading or trailing spaces.', ['password'])
    }, {
        name: 'password length',
        condition: (stepValues: AccountDetailsStepValues) => {
            return stepValues.password.length >= MIN_PASSWORD_LENGTH;
        },
        error: new ValidationError('Your password must be at least 6 characters long.', ['password'])
    }, {
        name: 'password confirmed',
        condition: (stepValues: AccountDetailsStepValues) => {
            // return stepValues.passwordsMatch;
            return stepValues.password === stepValues.confirmedPassword;
        },
        error: new ValidationError('Your passwords must match.', ['password', 'confirmedPassword'], 'confirmedPassword')
    }, {
        name: 'terms of service accepted',
        condition: (stepValues: AccountDetailsStepValues) => {
            return stepValues.termsOfServiceAccepted;
        },
        error: new ValidationError('Please review and accept the Terms of Service to continue.', ['termsOfServiceAccepted'])
    }];

export const AccountRegistrationValidation = (stepValues: AccountDetailsStepValues) => {
    return {
        errors: getStringErrors(getValidationErrorDictionary(validationChecks, stepValues)),
        valid: getValidationErrors(validationChecks, stepValues).length === 0
    }
}